<lu-datetime-picker
	[formControl]="formControl | fromAbstractToFormControl"
	[options]="componentOptions"
	[disabled]="to.disabled"
	[readonly]="to.readonly"
	[parentForm]="field.options.parentForm"
	(onDatetimePickerReady)="ready($event)"
	[attr.hasValue]="formControl?.value !== null && formControl?.value !== undefined"
	(ngModelChange)="change($event)">
</lu-datetime-picker>
